import api from './api';

export const groupTypeService = {
  // Get all group types
  getAllGroupTypes: async () => {
    const response = await api.get('/group-types');
    return response.data;
  },

  // Get group type by ID
  getGroupTypeById: async (id) => {
    const response = await api.get(`/group-types/${id}`);
    return response.data;
  },

  // Get group type by name
  getGroupTypeByName: async (name) => {
    const response = await api.get(`/group-types/name/${name}`);
    return response.data;
  },

  // Search group types
  searchGroupTypes: async (searchTerm) => {
    const response = await api.get(`/group-types/search?searchTerm=${encodeURIComponent(searchTerm)}`);
    return response.data;
  },

  // Get group types by creator
  getGroupTypesByCreator: async (createdBy) => {
    const response = await api.get(`/group-types/creator/${createdBy}`);
    return response.data;
  },

  // Get group types for user (based on permissions)
  getGroupTypesForUser: async (userId) => {
    const response = await api.get(`/group-types/for-user/${userId}`);
    return response.data;
  },

  // Create new group type
  createGroupType: async (groupTypeData, createdBy) => {
    const response = await api.post(`/group-types?createdBy=${createdBy}`, groupTypeData);
    return response.data;
  },

  // Update group type
  updateGroupType: async (id, groupTypeData, updatedBy) => {
    const response = await api.put(`/group-types/${id}?updatedBy=${updatedBy}`, groupTypeData);
    return response.data;
  },

  // Delete group type
  deleteGroupType: async (id, deletedBy) => {
    const response = await api.delete(`/group-types/${id}?deletedBy=${deletedBy}`);
    return response.data;
  }
}; 